<section>
  <h1 class="mb-3">{{titleText}}</h1>
  <p-messages key="personFormMsg" [closable]="true"></p-messages>
  <div>
    <form [formGroup]="personForm">
      <div [class.w-lg-50]="isStandaloneForm">
        <div class="mb-3">
          <label for="FirstName" class="form-label required-field">First name</label>
          <input id="FirstName" type="text" class="form-control" formControlName="FirstName" placeholder="First name" required aria-required="true" nessAutoFocus />
          <div class="invalid-feedback">
            Please enter a first name.
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="MiddleName">Middle name</label>
          <input id="MiddleName" type="text" class="form-control" formControlName="MiddleName" placeholder="Middle name" />
        </div>
        <div class="mb-3">
          <label for="LastName" class="form-label required-field">Last name</label>
          <input id="LastName" type="text" class="form-control" formControlName="LastName" placeholder="Last name" required aria-required="true" />
          <div class="invalid-feedback">
            Please enter a last name.
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="Suffix">Suffix</label>
          <input id="Suffix" type="text" class="form-control" formControlName="Suffix" placeholder="Suffix" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="Alias">Alias</label>
          <input id="Alias" type="text" class="form-control" formControlName="Alias" placeholder="Alias" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="NickName">Nickname</label>
          <input id="NickName" type="text" class="form-control" formControlName="NickName" placeholder="Nickname" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="GangName">Gang affiliation</label>
          <input id="GangName" type="text" class="form-control" formControlName="GangName" placeholder="Gang affiliation" />
        </div>
        <div class="mb-3">
          <label class="form-label" for="GenderID">Sex</label>
          <select #genderDD id="GenderID" class="form-select" formControlName="GenderID" (change)="personForm.get('GenderName').setValue(genderDD.options[genderDD.selectedIndex].label)">
            <option value="" selected>Select Sex</option>
            <ng-container *ngIf="lookupService.genders$ | async as genders;else loadingGenders">
              <option *ngFor="let gender of genders" value="{{gender.GenderID}}">{{gender.GenderName}}</option>
            </ng-container>
            <ng-template #loadingGenders><option value="">Loading genders...</option></ng-template>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label" for="RaceID">Race</label>
          <select #raceDD id="RaceID" class="form-select" formControlName="RaceID" (change)="personForm.get('RaceName').setValue(raceDD.options[raceDD.selectedIndex].label)">
            <option value="" selected>Select race</option>
            <ng-container *ngIf="lookupService.races$ | async as races;else loadingRaces">
              <option *ngFor="let race of races" value="{{race.RaceID}}">{{race.RaceName}}</option>
            </ng-container>
            <ng-template #loadingRaces><option value="">Loading races...</option></ng-template>
          </select>
        </div>
        <div class="mb-3">
          <label class="form-label" for="DateOfBirth">Date of birth <small>(Format: MM/DD/YYYY)</small></label>
          <p-calendar #dob inputId="DateOfBirth" formControlName="DateOfBirth" dateFormat="mm/dd/yy" [minDate]="minDateRule" [maxDate]="maxDateRule" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2050" [showIcon]="true" [showOnFocus]="false" styleClass="d-flex" inputStyleClass="form-control" (onBlur)="dateOnBlur(dob)"></p-calendar>
          <div class="invalid-feedback">
            Please enter a valid date with format: "MM/DD/YYY", and cannot be before 1900.
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="SSN">Social security number <small>(Format: 999-99-9999)</small></label>
          <p-inputMask inputId="SSN" formControlName="SSN" mask="999-99-9999" styleClass="form-control"></p-inputMask>
        </div>
        <div class="form-check form-check-inline mb-3">
          <input id="IsKnownFelon" class="form-check-input" type="checkbox" formControlName="IsKnownFelon" value="">
          <label class="form-check-label" for="IsKnownFelon">Is known felon?</label>
        </div>
      </div>
      <div [class.w-lg-75]="isStandaloneForm">
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">FBI file numbers</caption>
            <thead>
              <tr>
                <th scope="col">FBI File number</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personFbiNumbers.length == 0"><td colspan="2">No FBI file numbers found.</td></tr>
              <tr *ngFor="let fn of personFbiNumbers; let i = index">
                <td>{{ fn.FBIFileNumber }}</td>
                <td><button type="button" (click)="removeFbiNumber(i)" aria-label="Delete FBI file number" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="p-3">
                  <div class="mb-3" [formGroup]="personFBINumbersForm">
                    <label class="form-label" for="FBINumber">FBI file number</label>
                    <input id="FBINumber" type="text" formControlName="FBIFileNumber" class="form-control" placeholder="FBI file number" />
                  </div>
                  <button type="button" (click)="insertFBINumber()" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add FBI number</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">State IDs</caption>
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">State ID number</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personStateIds.length == 0"><td colspan="3">No state ID numbers found.</td></tr>
              <tr *ngFor="let sid of personStateIds; let i = index">
                <td>{{ sid.StateName }}</td>
                <td>{{ sid.StateIDNumbers }}</td>
                <td><button type="button" (click)="removeStateId(i)" aria-label="Delete State ID" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" class="p-3">
                  <div class="row row-cols-lg-auto g-3 align-items-start mb-3" [formGroup]="personStateIdsForm">
                    <div class="col-12">
                      <label class="form-label" for="StateID">State</label>
                      <select #stateIdDD id="StateID" class="form-select" formControlName="StateID">
                        <option value="">Select state</option>
                        <ng-container *ngIf="lookupService.usStates$ | async as states; else loadingStates">
                          <option *ngFor="let state of states" value="{{state.StateID}}">{{state.StateName}}</option>
                        </ng-container>
                      </select>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="StateIDNumbers">State ID number</label>
                      <input id="StateIDNumbers" type="text" formControlName="StateIDNumbers" class="form-control" placeholder="State ID number" aria-required="true" required />
                      <div class="invalid-feedback">
                        Please enter the ID number.
                      </div>
                    </div>
                  </div>
                  <button type="button" (click)="insertStateId(stateIdDD.options[stateIdDD.selectedIndex].label)" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add state ID</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">City ID numbers</caption>
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">City</th>
                <th scope="col">City ID number</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personCityIds.length == 0"><td colspan="4">No city ID numbers found.</td></tr>
              <tr *ngFor="let cid of personCityIds; let i = index">
                <td>{{cid.StateName}}</td>
                <td>{{cid.CityName}}</td>
                <td>{{cid.CityIDNumber}}</td>
                <td><button type="button" (click)="removeCityId(i)" aria-label="Delete city ID" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" class="p-3">
                  <div class="row row-cols-lg-3 g-3 align-items-start mb-3" [formGroup]="personCityIdsForm">
                    <div class="col-12">
                      <label class="form-label" for="CityStateID">State</label>
                      <select id="CityStateID" class="form-select" formControlName="StateID" #cityStateID (change)="onSelectCityState($event['target']['value'])">
                        <option value="">Select state</option>
                        <ng-container *ngIf="lookupService.usStates$ | async as states;else loadingStates">
                          <option *ngFor="let state of states" value="{{state.StateID}}">{{state.StateName}}</option>
                        </ng-container>
                      </select>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="CityID">City</label>
                      <p-autoComplete inputId="CityID" [suggestions]="filteredCities$ | async" (completeMethod)="filterCities($event)" [size]="30" [minLength]="0" field="CityName" placeholder="Select city" [dropdown]="true" [forceSelection]="true" formControlName="CityID" [(ngModel)]="cities" inputStyleClass="form-control" [tabindex]="0" appendTo="body">
                        <ng-template let-city pTemplate="item">
                          {{city.CityName}}
                        </ng-template>
                        <ng-template let-city pTemplate="selectedItem">
                          {{city.CityID}}
                        </ng-template>
                      </p-autoComplete>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="CityIDNumber">City ID number</label>
                      <input id="CityIDNumber" type="text" formControlName="CityIDNumber" class="form-control" placeholder="City ID number" />
                    </div>
                  </div>
                  <button type="button" (click)="insertCityId(cityStateID.options[cityStateID.selectedIndex].label)" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add city ID</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">Social media</caption>
            <thead>
              <tr>
                <th scope="col">Social media</th>
                <th scope="col">Account name</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personSocialMediaIds.length == 0"><td colspan="3">No social media found.</td></tr>
              <tr *ngFor="let smid of personSocialMediaIds; let i = index">
                <td>{{ smid.SocialMediaTypeName }}</td>
                <td>{{ smid.SocialMediaHandle }}</td>
                <td><button type="button" (click)="removeSocialMedia(i)" aria-label="Delete social media" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" class="p-3">
                  <div class="row row-cols-lg-auto g-3 align-items-start mb-3" [formGroup]="personSocialMediasForm">
                    <div class="col-12">
                      <label class="form-label" for="SocialMediaTypeID">Social media type</label>
                      <select #socialMediaDD id="SocialMediaTypeID" class="form-select" formControlName="SocialMediaTypeID">
                        <option value="">Select social media</option>
                        <ng-container *ngIf="lookupService.socialMediaTypes$ | async as socialMedias;else loadingSocialMedia">
                          <option *ngFor="let socialMedia of socialMedias" value="{{socialMedia.SocialMediaTypeID}}">{{socialMedia.SocialMediaTypeName}}</option>
                        </ng-container>
                        <ng-template #loadingSocialMedia><option value="">Loading social media types...</option></ng-template>
                      </select>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="SocialMediaHandle">Account name</label>
                      <input id="SocialMediaHandle" type="text" formControlName="SocialMediaHandle" class="form-control" placeholder="Account name" />
                    </div>
                  </div>
                  <button type="button" (click)="insertSocialMediaId(socialMediaDD.options[socialMediaDD.selectedIndex].label)" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add social media</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">Driver's licenses</caption>
            <thead>
              <tr>
                <th scope="col">State</th>
                <th scope="col">License number</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="personDriversLicenseNumbers.length == 0"><td colspan="3">No driver license number found.</td></tr>
              <tr *ngFor="let dlid of personDriversLicenseNumbers;let i = index">
                <td>{{ dlid.StateName }}</td>
                <td>{{ dlid.DriversLicenseNumber }}</td>
                <td><button type="button" aria-label="Delete driver's license" class="btn btn-sm btn-danger" (click)="removeDriversLicense(i)"><i class="fas fa-times" aria-hidden="true"></i></button></td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" class="p-3">
                  <div class="row row-cols-lg-auto g-3 align-items-start mb-3" [formGroup]="personDriversLicenseNumberForm">
                    <div class="col-12">
                      <label class="form-label" for="LicenseStateID">State</label>
                      <select #driversLicenseStateDD id="LicenseStateID" class="form-control" formControlName="StateID">
                        <option value="">Select state</option>
                        <ng-container *ngIf="lookupService.usStates$ | async as states; else loadingStates">
                          <option *ngFor="let state of states" value="{{state.StateID}}">{{state.StateName}}</option>
                        </ng-container>
                      </select>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="DriversLicenseNumber">Driver's license number</label>
                      <input id="DriversLicenseNumber" type="text" formControlName="DriversLicenseNumber" class="form-control" placeholder="Driver license number" />
                    </div>
                  </div>
                  <button type="button" (click)="insertDriversLicense(driversLicenseStateDD.options[driversLicenseStateDD.selectedIndex].label)" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add driver's license</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">Phone number(s)</caption>
            <thead>
              <tr>
                <th scope="col">Phone number</th>
                <th scope="col">Type</th>
                <th scope="col">Primary</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="ENESS_XREF_PeoplePhoneNumbers.controls.length == 0"><td colspan="4">No phone numbers found.</td></tr>
              <tr formArrayName="ENESS_XREF_PeoplePhoneNumbers" *ngFor="let phone of ENESS_XREF_PeoplePhoneNumbers.controls; let i = index">
                <ng-container [formGroupName]="i">
                  <td>{{ phone.get('PhoneNumber').value | phoneNumberFormat }}</td>
                  <td>{{ phone.get('PhoneNumberType').value }} <ng-container *ngIf="!!phone.get('PhoneNumberOtherType').value">({{ phone.get('PhoneNumberOtherType').value }})</ng-container></td>
                  <td class="text-center">
                    <div class="form-check d-inline-block">
                      <input type="radio" name="IsPrimary" formControlName="IsPrimary" [checked]="phone.get('IsPrimary').value == true" (change)="onSelectPrimaryPhoneNumber(i)" aria-label="Primary phone number" class="form-check-input" [value]="true" />
                    </div>
                    <div class="cross-validation-feedback" *ngIf="personForm.get('ENESS_XREF_PeoplePhoneNumbers').hasError('onlyOne')">
                      Please indicate which is the primary phone number.
                    </div>
                  </td>
                  <td class="text-center">
                    <button type="button" (click)="removePhoneNumber(i)" aria-label="Delete phone number." class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i></button>
                  </td>
                </ng-container>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" class="p-3">
                  <div class="row row-cols-lg-auto g-3 align-items-start mb-3" [formGroup]="phoneNumberFormGroup">
                    <div class="col-12">
                      <label for="PhoneNumber" class="form-label required-field">Phone number(s)</label>
                      <p-inputMask inputId="PhoneNumber" formControlName="PhoneNumber" mask="(999) 999-9999" styleClass="form-control" [ariaRequired]="true" [maxlength]="80"></p-inputMask>
                      <div class="invalid-feedback" *ngIf="phoneNumberFormGroup.get('PhoneNumber').invalid">
                        Please enter a phone number.
                      </div>
                    </div>
                    <div class="col-12">
                      <label for="PhoneNumberTypeID" class="form-label required-field">Type</label>
                      <select #phoneTypeDD id="PhoneNumberTypeID" formControlName="PhoneNumberTypeID" class="form-select" aria-required="true" required>
                        <option value="">Select a phone type</option>
                        <ng-container *ngIf="lookupService.phoneNumberTypes$ | async as phoneNumberTypes">
                          <option *ngFor="let phoneType of phoneNumberTypes" value="{{phoneType.PhoneNumberTypeID}}">{{ phoneType.PhoneNumberType }}</option>
                        </ng-container>
                      </select>
                      <div class="invalid-feedback">
                        Please select a phone number type.
                      </div>
                    </div>
                    <div class="col-12" [class.d-none]="phoneNumberFormGroup.get('PhoneNumberOtherType').disabled">
                      <label for="PhoneNumberOtherType" class="form-label required-field text-nowrap">Other type (80 chars max)</label>
                      <input id="PhoneNumberOtherType" type="text" formControlName="PhoneNumberOtherType" class="form-control" maxlength="80" aria-required="true" required />
                      <div class="invalid-feedback">
                        <p *ngIf="phoneNumberFormGroup.get('PhoneNumberOtherType').hasError('required')">Please specify other phone number type.</p>
                        <p *ngIf="phoneNumberFormGroup.get('PhoneNumberOtherType').hasError('maxlength')">The maximum length for other phone number type is 80 characters.</p>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-check form-check-vertical-center">
                        <label class="form-check-label" for="IsPrimary">
                          Is primary?
                        </label>
                        <input type="checkbox" id="IsPrimary" formControlName="IsPrimary" class="form-check-input" />
                      </div>
                    </div>
                  </div>
                  <button type="button" [disabled]="phoneNumberFormGroup.invalid" (click)="insertPhoneNumber(phoneTypeDD.options[phoneTypeDD.selectedIndex].label)" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add phone number</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive">
          <p-messages key="personAddressMsg" [closable]="true"></p-messages>
          <table class="temp-bs table table-sm table-striped table-bordered">
            <caption class="caption-top form-label text-body">Address(es)</caption>
            <thead>
              <tr>
                <th scope="col">Address</th>
                <th scope="col">Person address type</th>
                <th scope="col">Other Address type</th>
                <th scope="col">Primary</th>
                <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
              </tr>
            </thead>
            <tbody class="people-address-active">
              <tr *ngIf="ENESS_XREF_PeopleAddresses.controls.length == 0"><td colspan="5">No address found.</td></tr>
              <tr formArrayName="ENESS_XREF_PeopleAddresses" *ngFor="let padd of ENESS_XREF_PeopleAddresses.controls; let i = index">
                <ng-container [formGroupName]="i">
                  <td>
                    {{ padd.value.ENESS_Address.ConsolidatedAddressReturned }}
                  </td>
                  <td>
                    <select #addressTypeDD id="AddressType{{i}}" class="form-select" formControlName="AddressTypeID" (change)="onAddressTypeChange(addressTypeDD.options[addressTypeDD.selectedIndex].value, i)" aria-required="true" required>
                      <option value="">Select address type</option>
                      <ng-container *ngIf="personService.addressTypes$ | async as addressTypes; else loadingAddressTypes">
                        <option *ngFor="let addressType of addressTypes" value="{{addressType.AddressTypeID}}">{{addressType.AddressTypeName}}</option>
                      </ng-container>
                    </select>
                    <div class="invalid-feedback">
                      Please select address type.
                    </div>
                  </td>
                  <td>
                    <input type="text" class="form-control" formControlName="OtherAddressType" aria-label="Other address type" placeholder="Other address type" maxlength="80" />
                    <div class="invalid-feedback" *ngIf="padd.get('OtherAddressType').invalid">
                      <p *ngIf="padd.get('OtherAddressType').hasError('required')">Please specify other address type.</p>
                      <p *ngIf="padd.get('OtherAddressType').hasError('maxlength')">The maximum length for other address type is 80 characters.</p>
                    </div>
                  </td>
                  <td class="text-center">
                    <div class="form-check">
                      <input type="radio" formControlName="IsCurrent" [checked]="padd.get('IsCurrent').value == true" (change)="onPrimaryAddressChange($event, i)" name="IsCurrent" aria-label="Is the primary address?" class="form-check-input" [value]="true" />
                    </div>
                    <div class="cross-validation-feedback" *ngIf="personForm.get('ENESS_XREF_PeopleAddresses').hasError('onlyOne')">
                      Please select the primary address.
                    </div>
                  </td>
                  <td class="text-center"><button type="button" aria-label="Delete address" class="btn btn-sm btn-danger" (click)="removeAddress(i)"><i class="fas fa-times" aria-hidden="true"></i></button></td>
                </ng-container>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="5" class="p-3">
                  <button type="button" (click)="onOpenFindExistingLocationClick()" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add from existing address</button>
                  <button type="button" (click)="onAddNewLocationClick()" class="btn btn-sm btn-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new address</button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="mb-3">
          <h2 class="h4">Attachments</h2>
          <div class="notes mb-3">
            Notes:
            <ol>
              <li><i>Total # of upload files allowed: {{ totalNumberOfUploadFilesAllowed }}</i></li>
              <li><i>Max size allowed per file: 5MB</i></li>
              <li><i>File types supported: PDF, JPG, PNG, TIFF, JPEG, ANB, DOC, DOCX, XLS, XLSX, PPT, PPTX, MSG</i></li>
            </ol>
          </div>
          <p-fileUpload #fileInput
                        id="PersonAttachmentUpload"
                        [accept]="allowedFileTypes"
                        [maxFileSize]="maxFileSize"
                        [multiple]="true"
                        [fileLimit]="totalNumberOfUploadFilesAllowed"
                        [customUpload]="true"
                        [showUploadButton]="false"
                        [showCancelButton]="false"
                        (uploadHandler)="uploadPersonAttachments($event)"
                        (onError)="onUploadErrorHandler($event)"
                        (onSelect)="onSelectAttachment($event)"
                        [auto]="false"
                        chooseLabel="Choose"
                        invalidFileSizeMessageSummary="{0}: Invalid file size."
                        invalidFileSizeMessageDetail="Maximum upload size is {0}. File was NOT uploaded."
                        [invalidFileLimitMessageSummary]="_maxFileLimitExceededMsg"
                        invalidFileLimitMessageDetail="Limit is {0} files."
                        styleClass="mb-3">
          </p-fileUpload>
          <div class="cross-validation-feedback fw-bold mb-3" *ngIf="displayAttachmentErrorMessage">
            {{ attachmentUploadErrorMessage}}
          </div>
          <p-table [value]="personAttachments" styleClass="mb-3" *ngIf="personAttachments.length > 0">
            <ng-template pTemplate="caption">
              <div class="p-2 fw-medium text-center">
                Uploaded attachments
              </div>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th scope="col">File name</th>
                <th scope="col">Created by</th>
                <th scope="col">Upload date</th>
                <th scope="col" class="w-10"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">
                  No uploaded attachments found.
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
              <tr>
                <th scope="row">{{rowData.FileName}}</th>
                <td>{{rowData.CreatedBy}}</td>
                <td>{{rowData.CreatedOn | date:'MM/dd/yyyy'}}</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-danger" aria-label="Remove attachment" (click)="deleteUploadedAttachment(rowIndex)"><i class="fas fa-times" aria-hidden="true"></i></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div class="mb-3">
          <label class="form-label" for="EmailAddress">Email address <small>(Format: xxx&#64;xxx.xxx)</small></label>
          <input id="EmailAddress" type="email" class="form-control" formControlName="EmailAddress" />
          <div class="invalid-feedback">
            The email address must be 128 characters or less.
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label" for="PersonDescription">Description</label>
          <textarea [rows]="textAreaRows" id="PersonDescription" class="form-control" formControlName="PersonDescription" placeholder="Description"></textarea>
          <div class="invalid-feedback">
            The description must be 600 characters or less.
          </div>
        </div>
      </div>
      <div>
        <button type="button" [disabled]="personForm.invalid" (click)="onOpenConfirmation()" class="btn btn-active mb-3">{{ isEventAddEditPersonForm ?  (mode == 'add' ? 'Associate person with event' : 'Save person') : 'Save person' }}</button>
        <button *ngIf="isEventAddEditPersonForm || isEventPerson" type="button" (click)="closePersonForm()" class="btn btn-active mb-3">Close</button>
      </div>
    </form>
  </div>
</section>
<ng-template #loadingStates><option value="">Loading states...</option></ng-template>
<ng-template #loadingAddressTypes><option value="">Loading address types...</option></ng-template>
<p-sidebar [(visible)]="displaySidebar" (onShow)="onShowSidebar()" (onHide)="onSidebarClose()" position="right" [blockScroll]="true" styleClass="p-sidebar-lg" [showCloseIcon]="false">
  <ng-container *ngIf="openNewLocationForm">
    <ness-location-form [searchLocation]="searchAddress$ | async" [titleText]="addEditLocationTitleText" [isEventLocationForm]="true" [isPersonAddressForm]="true" [associationButtonLabel]="associationButtonLabel" (associateLocation)="onNewLocationAdded($event)" (closeForm)="onNewLocationClose()"></ness-location-form>
  </ng-container>
  <ng-container *ngIf="openFindExistingLocationForm">
    <ness-find-existing-location [associationButtonLabel]="existingLocationAssociationButtonLabel" (associateLocation)="onAddExistingLocations($event)" (closeForm)="onAddExistingLocationsClose()"></ness-find-existing-location>
  </ng-container>
</p-sidebar>
<p-dialog [(visible)]="showConfirmEdit" [breakpoints]="{'992px': '75vw', '576px': '90vw'}" [style]="{ width: '50vw' }" [draggable]="false" [modal]="true" [resizable]="true" [baseZIndex]="10000" styleClass="disclaimerDialog" appendTo="body">
  <p-header>
    <i aria-hidden="true" class="p-1 me-1 fas fa-exclamation-triangle fa-1x"></i>
    Data Change Warning
  </p-header>
  <p>
    All NESS data related to this person will reflect these changes.  Do you wish to continue?
  </p>
  <div>
    <button type="button" class="btn btn-active" (click)="savePerson()" value="Submit">Save</button>
    <button type="button" class="btn btn-secondary" (click)="closePersonForm()" value="Cancel">Cancel</button>
  </div>
</p-dialog>
